/** @jsxImportSource @emotion/react */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snack, Snackbar } from '@nike/eds';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import { requestsSelectors } from '../requests/reducer';
import { RequestsEnum } from '../requests/enum';

import { invitationsActions } from './invitations/actions';
import { usersActions } from './users/actions';

const UserManagementSuccessSnackbar = () => {
  const dispatch = useDispatch();

  const invitationSuccess = useSelector(requestsSelectors.invitationSuccess);
  const updateUserSuccess = useSelector(requestsSelectors.updateUserSuccess);

  return (
    <Snackbar>
      {(invitationSuccess || updateUserSuccess) && (
        <Snack
          status='success'
          className='eds--dark'
          css={{ color: '#fff' }}
          onDismiss={() => {
            dispatch({
              type: RequestsEnum.REQUEST_FINISHED,
              payload: {
                name: invitationSuccess ? invitationsActions.issueInvitation.name : usersActions.updateUser.name
              }
            });
          }}
          autoDismissDuration='5000'
        >
          <TranslatedCopy id='userManagement.action.success' />
        </Snack>
      )}
    </Snackbar>
  );
};

export default UserManagementSuccessSnackbar;
